import { Form, Radio, RadioChangeEvent, Row } from "antd";
import React from "react";
import { TenantType } from "../../../../../types/bookings";

type TenantTypeRadioProps = {
  tenantType: TenantType;
  onChange?: (tenantType: TenantType) => void;
  isDisabled?: boolean;
};

export const TenantTypeRadio = (props: TenantTypeRadioProps) => {
  const { tenantType, onChange, isDisabled } = props;

  const handleChange = (event: RadioChangeEvent) => {
    onChange?.(event.target.value);
  };

  return (
    <Row>
      <Form.Item label="Tenant Type" name="tenantType">
        <Radio.Group
          optionType="default"
          defaultValue={tenantType}
          disabled={isDisabled}
          onChange={handleChange}
          options={[
            { label: "Company", value: "company" },
            { label: "Individual", value: "individual" },
          ]}
        />
      </Form.Item>
    </Row>
  );
};
